// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/sample-parts/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const samplePartsEN: PageEntry = {
  id: "post.musterteile",
  locale: "en",
  slug: "sample-parts",
  seo: {
    title: "Glossary: Sample parts explained simply | Dietz GmbH",
    description: "Sample parts are physical specimens or components that are produced during the sample development and production process. These parts serve as representative models for the final p",
  },
  type: "post",
  h1: "Glossary: Sample parts explained simply",
  intro: "Sample parts are physical specimens or components that are produced during the sample development and production process. These parts serve as representative models for the final product and are used to verify design aspects, functionality and quality. Sample parts can be found in various industries, from the automotive industry to electronics production. Careful production and testing of sample parts is crucial to ensure that the final product meets requirements and expectations.",
  blocks: [

  ],
};
